export function Skeleton({ className = '' }) {
  return <div className={`animate-pulse bg-on-background/10 ${className}`} />
}
